import { isEqual, isNil, mapValues, PropertyPath, toArray } from 'lodash'
import { LodashPick2x1 } from 'lodash/fp'

export type FormValues<DataType extends Record<string, any>> = NonNullable<
  {
    [P in keyof DataType]-?: DataType[P] | EmptyFormValue
  }
>

export type EmptyFormValue = ''

export const EMPTY_FORM_VALUE: EmptyFormValue = ''

export function pickOrCreate(props: PropertyPath): LodashPick2x1 {
  const keys = toArray(props) as any[]
  return (data: any) => {
    const parsedObject = {}
    keys.forEach((key) => {
      parsedObject[key] = data[key]
    })
    return parsedObject
  }
}

export function parseNilToEmptyString<DataType extends Record<string, any>>(data: DataType): FormValues<DataType> {
  return mapValues(data, (dataValue) => (isNil(dataValue) ? EMPTY_FORM_VALUE : dataValue)) as any
}

export function parseEmptyStringToNil<DataType extends Record<string, any>>(data: FormValues<DataType>): DataType {
  return mapValues(data, (dataValue: any) => (dataValue === EMPTY_FORM_VALUE ? undefined : dataValue)) as any
}

export function getChangedData<T extends Record<string, any>>(initialValues: T, updatedValues: T): Partial<T> {
  const dataKeys = [...Object.keys(initialValues), ...Object.keys(updatedValues)]
  return dataKeys.reduce((resultObj, key) => {
    const initialValue = initialValues[key]
    const updatedValue = updatedValues[key]
    if (!isEqual(initialValue, updatedValue)) {
      resultObj[key] = updatedValue
    }
    return resultObj
  }, {})
}
